<template>
    <div id="SearchTaahod">
        <card>
            <template v-slot:header>
                <h4 class="d-inline">جستجوی تعهدات</h4>
            </template>
            <template v-slot:content>
                <div class="row">
                    <div  id="ShomareOzv" class="col-md-2  col-12 mt-2 ">
                    <small>کد مشتری</small>
                    <input type="text" v-mask="$Get_FormatShomareOzv()" @keydown="SearchShomareozv($event)"
                        :placeholder="$session.get('UserInfo').codeShobe.trim() + '-'" class="form-control" dir="ltr"
                        v-model="DataAxios.ArryfildValue.ShomareOzv" />
                </div>
                <div  id="CodeMeli" class="col-md-2  col-12 mt-2 ">
                    <small>کد ملی </small>
                    <input type="text" v-mask="'##########'" maxlength="10" @keypress="$ValidNumber($event, 10)"
                        @input="$CheckupLengthCodeMeli($event)" class="form-control required-CodeMeli text-left"
                        v-model="DataAxios.ArryfildValue.CodeMeli" />
                </div>
                <div  id="OzvName" class="col-md-2  col-12 mt-2 ">
                    <small>نام </small>
                    <input type="text" class="form-control" v-model="DataAxios.ArryfildValue.OzvName" />
                </div>
                <div  id="OzvFamily" class="col-md-2  col-12 mt-2 ">
                    <small>نام خانوادگی </small>
                    <input type="text" class="form-control" v-model="DataAxios.ArryfildValue.OzvFamily" />
                </div>
                <div  id="Mobile" class="col-md-2  col-12 mt-2">
                    <small>تلفن همراه </small>
                    <input type="text" dir="ltr" v-mask="'09#########'" placeholder="09_________"
                        @keypress="$ValidNumber($event, 11)" class="form-control"
                        v-model="DataAxios.ArryfildValue.Mobile" />
                </div>
                <div  id="Shenasname" class="col-md-2  col-12 mt-2">
                    <small>شماره شناسنامه </small>
                    <input type="text" dir="ltr" v-mask="'##########'" class="form-control"
                        v-model="DataAxios.ArryfildValue.Shenasname" />
                </div>
                </div>

                <div class="row mt-2 text-left mr-1">
                <button class="btn btn-success m-1 float-left" dir="ltr" @click="Search" >
                    <span class="mr-2">جستجــو </span><span class="fa fa-search"></span>
                </button><br /></div>
            </template>

        </card>
                    <BnpGrid v-if="$store.state.renderComponentGrid"  :propsRows="rows" :propsColumn="columns" :action="true" :hasRowNum="true" :Sortable="true" >
                <template slot="action-slot" slot-scope="props">
                    <a href="#" class="badge badge-success font-weight-normal p-2 m-1" data-dismiss="modal" @click.prevent="OnDetail(props.props)" >انتخاب </a>
                </template>
            </BnpGrid>
    </div>
</template>
<script>
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
import Card from '@/components/Card/Card.vue'
    export default {
        components: {
            Card,BnpGrid
        },
        data() {
            return {
                 DataAxoisColumns: {
                ArryfildValue: {
                SoftwareId: 2,
                UserId: 1,
                FormName: "frmSearchTaahod",
                ShowView: 0,
                },
                Method: "post",
                Action: "ReadGridColumns",
            },
             DataAxios: {
                ArryfildValue: {ShomareOzv: "",        TblAzaNoeId: 0,        TblSarfaslTypeId: [1, 2, 13, 6],       
                 CodeMeli: "",        OzvName: "",        OzvFamily: "",        Mobile: "",        Shenasname: "",      
                   TblGrpId: "",        OzvFamilyName: "",},
                            },
            rows: [],
            columns: [
            { name: 'ShomareOzv', label: 'شماره مشتری', visibility: true },
            { name: 'OzvFamilyName', label: 'مشخصات', visibility: true },
            { name: 'CodeMeli', label: 'کدملی', visibility: true },
            { name: 'DesNoe', label: 'شرح تعهد', visibility: true },
            { name: 'Vcode', label: 'شماره تعهد', visibility: true },
            { name: 'Mande', label: 'مانده', visibility: true },
 
            ],
            
            }
        },
         methods: {
            SearchShomareozv(e) {
            if (e.key == "Enter") {
                e.target.value = e.target.value.replace(
                this.$session.get("UserInfo").codeShobe.trim() + "-",
                ""
                );
                var shomare = this.$session
                .get("b_SetShomareOzvMask")
                .trim()
                .substring(4)
                .replaceAll("0", "#");
                e.target.value = e.target.value.padStart(shomare.length, 0);
                e.target.value =
                this.$session.get("UserInfo").codeShobe.trim() + "-" + e.target.value;
                this.DataAxios.ArryfildValue.ShomareOzv = e.target.value;
            }
            },
            Search() {
            try {
                this.DataAxios.ArryfildValue.TblGrpId = this.$session.get("UserInfo").tblGrpId;
                this.DataAxios.ArryfildValue.TblSarfaslTypeId =this.tblSarfaslTypeId != undefined ? [this.tblSarfaslTypeId] : [1, 2, 13, 6];
                this.DataAxios.Action = "SearchTaahod";
                this.DataAxios.Method = "post";
                this.$PostData(this.DataAxios).then((data) => {
                if (data.length > 0) {
                    this.posts = data;
                    if (this.posts != null) {
                    let info;
                    let list = [];
                    for (let index = 0; index < this.posts.length; index++) {
                        info = this.posts[index];
                        info["row"] = index + 1;
                        list.push(info);
                    }
                    this.rows = list;
                    this.rows = this.$FormatMablaghGrid(this.rows);
                    }
                    this.$store.state.renderComponentGrid = false;
                    this.$nextTick(() => {
                    this.$store.state.renderComponentGrid = true;
                    });
                } else {
                    this.rows = [];
                    this.$mySweetDefaultTost("عدم وجود اطلاعات","اطلاعاتی وجود ندارد ","info",3000);
                }
                });
            } catch (error) {
                console.log(error);
            }
            },
            OnDetail(row) {
            this.$emit("Taahod", row);
            this.$store.state.Modal=false
            },
        },
         created() {
        },
        mounted() {
           
        },
        props: ["tblSarfaslTypeId", "NoRouteForm"],
    }
</script>
<style scoped>

</style>